import FlexPane from './_flex-pane.js'
import EventCardsCarousel from './_event-cards-carousel.js'
import NextRacesController from './_next-races-controller.js'
import MenuLinkPromotions from './_menu-link-promotions.js'
import RaceCoupons from './_race-coupons.js'

export default {
  name: 'HighlightsView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          padding: '8px 0 0 0',
          flexDirection: 'column',
        },
      },
    },
    eventCardsCarousel: {
      configSet: EventCardsCarousel,
      configValues: {
        skeletonLoader: {
          disableLoader: true,
        },
        minCardsNumber: 1,
        swiper: {
          style: {
            _mobile_padding: '0 8px',
          },
        },
      },
    },
    nextRacesController: {
      configSet: NextRacesController,
      configValues: {
        view: {
          nextOffHeaderContainer: {
            style: {
              minHeight: '40px',
              alignItems: 'center',
            },
          },
          nextOffHeader: {
            container: {
              padding: '8px',
              _mobile_padding: '8px 8px 8px 16px',
            },
          },
          swiper: {
            style: {
              padding: '0 8px 2px',
              _mobile_scrollPaddingLeft: '8px',
              _mobile_scrollPaddingRight: '8px',
            },
          },
        },
      },
    },
    menuLinkPromotions: {
      configSet: MenuLinkPromotions,
      configValues: {
        extraLinksInFront: true,
        skeletonLoader: {
          disableLoader: true,
        },
        menuRow: {
          style: {
            container: {
              justifyContent: 'left',
            },
          },
          buttonScrollPane: {
            contentContainer: {
              itemSpacing: '8px',
            },
            scrollPaneContainer: {
              style: {
                flexGrow: 0,
              },
            },
            leftScrollButtonContainer: {
              style: {
                left: '-4px',
              },
            },
          },
          itemInnerContainer: {
            style: {
              padding: '0 16px',
            },
          },
        },
      },
    },
    raceCoupons: {
      configSet: RaceCoupons,
      configValues: {
        viewType: 'highlights',
        initiallyExpandedMeetings: -1,
        raceCouponsView: {
          mainContainer: {
            style: {
              _mobile_padding: '0 8px',
            },
          },
          couponContainer: {
            style: {
              padding: '0',
            },
          },
          collapsibleMeetingPane: {
            raceMeetingCoupon: {
              maxButtonsInRow: 8,
              _mobile_maxButtonsInRow: 4,
            },
          },
          raceCouponsSkeleton: {
            maxButtonsInRow: 8,
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
